import { useNavigate } from "react-router-dom";
import MobileBottomNav from "../../components/feature/MobileBottomNav";

const BILL_CATEGORIES = [
  {
    id: "airtime",
    label: "Airtime",
    description: "Top up any network",
    icon: "ri-phone-line",
    color: "#059669",
    bg: "#ECFDF5",
    path: "/bills/airtime",
  },
  {
    id: "data",
    label: "Data Bundle",
    description: "Buy internet data",
    icon: "ri-wifi-line",
    color: "#0284C7",
    bg: "#EFF6FF",
    path: "/bills/data",
  },
  {
    id: "electricity",
    label: "Electricity",
    description: "Pay DISCO bills",
    icon: "ri-flashlight-line",
    color: "#D97706",
    bg: "#FFFBEB",
    path: "/bills/electricity",
  },
  {
    id: "tv",
    label: "Cable TV",
    description: "DSTV, GOtv, Startimes",
    icon: "ri-tv-2-line",
    color: "#7C3AED",
    bg: "#F5F3FF",
    path: "/bills/tv",
  },
  // {
  //   id: "internet",
  //   label: "Internet",
  //   description: "Broadband & fibre",
  //   icon: "ri-router-line",
  //   color: "#0F766E",
  //   bg: "#F0FDFA",
  //   path: "/bills/internet",
  // },
  // {
  //   id: "betting",
  //   label: "Betting",
  //   description: "Fund betting wallets",
  //   icon: "ri-gamepad-line",
  //   color: "#DC2626",
  //   bg: "#FEF2F2",
  //   path: "/bills/betting",
  // },
];

const QUICK_ACTIONS = [
  { label: "MTN Airtime", icon: "ri-phone-line", color: "#F59E0B", path: "/bills/airtime?network=MTN" },
  { label: "EKEDC", icon: "ri-flashlight-line", color: "#D97706", path: "/bills/electricity?disco=EKEDC" },
  { label: "DSTV", icon: "ri-tv-2-line", color: "#1D4ED8", path: "/bills/tv?provider=DSTV" },
  { label: "Glo Data", icon: "ri-wifi-line", color: "#059669", path: "/bills/data?network=GLO" },
];

export default function BillsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F7F8FA] pb-28">
      {/* Header */}
      <div className="bg-white px-5 pt-12 pb-5 border-b border-slate-100">
        <div className="flex items-center gap-3 mb-1">
          <button
            onClick={() => navigate("/home")}
            className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center"
          >
            <i className="ri-arrow-left-line text-slate-600 text-lg" />
          </button>
          <div>
            <h1 className="text-slate-800 font-bold text-lg" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              Pay Bills
            </h1>
            <p className="text-slate-400 text-xs">Fast, easy, instant</p>
          </div>
        </div>
      </div>

      <div className="px-5 pt-5 space-y-6">
        {/* Quick Access */}
        <div>
          <p className="text-slate-500 text-xs font-semibold uppercase tracking-wider mb-3">
            Quick Access
          </p>
          <div className="grid grid-cols-4 gap-2">
            {QUICK_ACTIONS.map((action) => (
              <button
                key={action.label}
                onClick={() => navigate(action.path)}
                className="flex flex-col items-center gap-2 bg-white rounded-2xl py-4 px-2 border border-slate-100 hover:border-emerald-200 hover:bg-emerald-50/50 transition-all active:scale-95"
              >
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ background: action.color + "18" }}
                >
                  <i className={`${action.icon} text-lg`} style={{ color: action.color }} />
                </div>
                <span className="text-slate-600 text-[10px] font-semibold text-center leading-tight">
                  {action.label}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* All Categories */}
        <div>
          <p className="text-slate-500 text-xs font-semibold uppercase tracking-wider mb-3">
            All Services
          </p>
          <div className="grid grid-cols-2 gap-3">
            {BILL_CATEGORIES.map((cat) => (
              <button
                key={cat.id}
                onClick={() => navigate(cat.path)}
                className="bg-white rounded-2xl p-4 border border-slate-100 hover:border-emerald-200 transition-all active:scale-95 text-left flex items-center gap-3"
              >
                <div
                  className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0"
                  style={{ background: cat.bg }}
                >
                  <i className={`${cat.icon} text-xl`} style={{ color: cat.color }} />
                </div>
                <div className="min-w-0">
                  <p className="text-slate-800 font-bold text-sm" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                    {cat.label}
                  </p>
                  <p className="text-slate-400 text-xs mt-0.5 truncate">{cat.description}</p>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Recent Bills Placeholder */}
        <div>
          <p className="text-slate-500 text-xs font-semibold uppercase tracking-wider mb-3">
            Recent Payments
          </p>
          <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden divide-y divide-slate-50">
            {[
              { label: "MTN Airtime", amount: "₦1,000", date: "Today, 10:42 AM", icon: "ri-phone-line", color: "#F59E0B", status: "success" },
              { label: "DSTV Compact", amount: "₦7,900", date: "Yesterday", icon: "ri-tv-2-line", color: "#1D4ED8", status: "success" },
              { label: "EKEDC Prepaid", amount: "₦5,000", date: "May 4", icon: "ri-flashlight-line", color: "#D97706", status: "success" },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-3 px-4 py-3">
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ background: item.color + "15" }}
                >
                  <i className={`${item.icon} text-lg`} style={{ color: item.color }} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-slate-800 text-sm font-semibold">{item.label}</p>
                  <p className="text-slate-400 text-xs">{item.date}</p>
                </div>
                <div className="text-right">
                  <p className="text-slate-800 text-sm font-bold">{item.amount}</p>
                  <p className="text-emerald-600 text-xs font-medium">Paid</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <MobileBottomNav />
    </div>
  );
}
